import React from 'react'
import styled, { css } from 'styled-components'
import { accents, brand } from 'sutra/tokens/colors'

export type BadgeTone = 'coral' | 'ai'

export interface BadgeProps {
  $tone?: BadgeTone
  children?: React.ReactNode
  className?: string
}

const toneStyles: Record<BadgeTone, ReturnType<typeof css>> = {
  coral: css`
    background: ${brand.sunriseCoral[500]};
  `,
  ai: css`
    background: ${accents.reflectionBlue[500]};
  `,
}

const StyledBadge = styled.span<{ $tone: BadgeTone }>`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  color: ${brand.white};
  font-size: 11px;
  font-weight: 600;
  padding: 4px 8px;
  border-radius: 6px;
  line-height: 1;
  white-space: nowrap;
  ${({ $tone }) => toneStyles[$tone]}
`

export const Badge = ({
  $tone = 'coral',
  children,
  className,
}: BadgeProps): React.ReactElement => (
  <StyledBadge $tone={$tone} className={className}>
    {children}
  </StyledBadge>
)

Badge.displayName = 'Badge'
